module.exports = __webpack_public_path__ + "static/media/VV.c201e888.jpg";